import * as utility from "../services.js"
import * as common_components from "../editor_common_components.js"
import * as react_components from "../reactcomponent.js"
import * as ui_editor_Components from "./ui_editor_component_tree.js"
import * as datastore from "../stores/statisticsDataStore.js"
import { StatisticViewer, registerComponents } from "../statistic_ui.js"
import * as propertyTypes from "../property_types.js"
import { Innosoft_InnoBI_Controllers_StatisticUiController as StatisticUiController } from "../generated_api/generated_api.js"
import { getGlobalSettings } from "../settings.js"
import { NotificationHelper } from "../../core/util/notificationHelper.js"
import { Menu, EntryType } from "../../core/components/menu.js"
import { TextEditorProps, MonacoEditor } from "../../core/components/monacoEditor.js"
import { ReactComponentEditor } from "../service_report/property_editor_extensions/react_component_editor.js"
import { ErrorBoundary } from "../components/error_boundary.js"
import { General } from "../../../siteManagement/general.js"
import { Helper } from "../../core/util/helper.js"
import React from "react";
export { registerComponents };

export class UiEditor extends React.Component<any, any>{

    constructor(props, context) {
        super(props, context);
        let state: any = { ui: {}, uiValues: {}, selectedTab: 0, hasUnsavedChanges: false };
        state.dataStore = new datastore.StatisticDataStore(null, null);
        this.reloadConfig(this.props.match.params.statisticId);
        this.state = state;
    }

    reloadConfig = (statisticId) => {
        let that = this;
        new StatisticUiController().GetStatisticConfig(statisticId, (result) => {
            General.Sheet.Manager.getTopMostSheet().setTitle(result.Name);
            //Storagekey = parameterStorageKey, StorageValue
            if (Helper.hasValue(result.StoredParams?.StorageValue)) {
                Helper.saveDataToStorage(result.StoredParams.StorageKey, result.StoredParams.StorageValue, true);
            }
            that.setState({ name: result.Name, ui: result.Config, sourceCode: result.StatisticController, contextVariables: result.ContextVariables, description: result.Description, isInternalStatistic: result.IsInternal });
        });
    }

    routerWillLeave = (nextLocation) => {
        if (this.state.hasChanges === true && this.canSaveStatistic()) {
            return "Discard unsaved changes?";
        }
    }

    UNSAFE_componentWillMount() {
        var that = this;
        window["safeToUnload"] = function () {
            return that.routerWillLeave(null);
        };
    }

    componentWillUnmount() {
        delete window["safeToUnload"];
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.reloadConfig(nextProps.match.params.statisticId);
    }

    handleDeleteElement = (row, element) => {
        let index = row.indexOf(element);
        if (index > -1) {
            row.splice(index, 1);
        }
        this.setState({ selectedElement: null, hasChanges: true })
    }

    handleDeleteRow = (row, parent) => {
        let index = parent.indexOf(row);
        if (index > -1) {
            parent.splice(index, 1);
        }
        this.setState({ selectedElement: null, hasChanges: true });
    }

    handleAddListItem = (parent, item) => {
        parent.push(item);
        this.setState({ selectedElement: null, hasChanges: true })
    }

    handleValueChanged = (name, value) => {
        this.state.uiValues[name] = value;
        this.setState({ uiValues: this.state.uiValues, hasChanges: true });
    }

    handleElementClicked = (element) => {
        this.selectedElementChange(element);
    }

    handleSettingsChanged = (newSettings) => {
        var element = this.state.selectedElement;
        element = Object.assign(element, newSettings);

        this.setState({ selectedElement: element, hasChanges: true });
    }

    selectedElementChange = (element) => {
        let currentSelectedElement = this.state.selectedElement;
        if (currentSelectedElement) {
            currentSelectedElement['_!!_isSelectedInEditor'] = false;
        }

        if (element) {
            element['_!!_isSelectedInEditor'] = true;
        }

        this.setState({ selectedElement: element });
    }

    handleAddElement = (row, type, isParameter) => {
        let obj = {
            type: type,
            width: isParameter === true ? 12 : 1
        };
        row.push(obj);

        this.setState({ selectedElement: null, hasChanges: true })
    }

    handleCopyElement = (row, element) => {
        let copy = $.extend({}, element);
        copy.uid = kendo.guid();
        row.push(copy);
        this.setState({ selectedElement: null, hasChanges: true })
    }

    handleMoveElement = (source, destination) => {
        let element = source.row[source.index];
        if (element) {
            source.row.splice(source.index, 1);
        }
        else {
            return;
        }
        element.uid = kendo.guid();
        destination.row.splice(destination.index, 0, element);
        this.setState({ selectedElement: null, hasChanges: true })

    }

    handleTabClicked = (index) => {
        this.setState({ selectedTab: index });
    }

    handleSave = () => {
        new StatisticUiController().Save(this.props.match.params.statisticId, { "name": this.state.name, "config": this.state.ui, "code": this.state.sourceCode, "description": this.state.description }, (result) => {
            NotificationHelper.showSuccessMessage("Saved successfully");
        });
        this.setState({ isSaving: true });
    }

    handleClose = () => {
        this.props.history.push({ pathname: "/uibuilder" });
    }

    handleSourceCodeChanged = (code) => {
        this.setState({ sourceCode: code, hasChanges: true });
    }

    handleDescriptionChanged = (description) => {
        this.setState({ description: description, hasChanges: true });
    }

    canSaveStatistic = () => {
        if (getGlobalSettings().GetSettings().INNO_IS_INTERNAL_USER == 1) {
            return true;
        }
        else if (this.state.isInternalStatistic == 1) {
            return false;
        }
        return true;
    }

    showWarningIfCantSave = () => {
        if (!this.canSaveStatistic()) {
            return <div style={{ backgroundColor: "red", minHeight: "20px", marginLeft: "10px" }}>This is an internal statistic. Changes can not be saved. Please create a copy.</div>
        }
    }

    getCustomEditor = (type: string): { component: typeof React.Component, customProps: any } => {
        if (type == "REACTTEMPLATEPROPERTY") {
            return {
                component: ReactComponentEditor, customProps: { extraLibs: [{ code: "" }] }
            };
        }
    }

    render() {

        let editorForElement = getEditorForSelectedElement(this.state.selectedElement);
        let instance;
        if (editorForElement && !Array.isArray(editorForElement)) {
            instance = propertyTypes.InstanceLoader.getInstance(editorForElement, null, null);
            instance.hydrateFromJS(this.state.selectedElement);
            editorForElement = instance.getMetadata();
        }

        let editor = (editorForElement == null) ? (null) : React.createElement(common_components.PropertiesEditor, {
            key: this.state.selectedElement.uid,
            properties: editorForElement,
            selectedElement: this.state.selectedElement,
            onValueChanged: this.handleValueChanged,
            onSettingsChanged: this.handleSettingsChanged,
            contextVariables: this.state.contextVariables,
            componentState: instance,
            customComponentResolver: this.getCustomEditor
        });

        var previewOrCode;
        if (this.state.selectedTab == 0) {
            previewOrCode = <UiPreview key="1" ui={this.state.ui} dataStore={this.state.dataStore} onValueChanged={this.handleValueChanged} values={this.state.uiValues} code={this.state.sourceCode} contextVariables={this.state.contextVariables} name={this.state.name} statisticId={this.props.match.params.statisticId} />
        } else if (this.state.selectedTab == 1) {

            previewOrCode = <div style={{ height: "500px" }}><UiBuilderEditor key="2" name="code" onTextChange={this.handleSourceCodeChanged} code={this.state.sourceCode} /></div>
        }
        else {
            previewOrCode = <DescriptionEditor key="3" onDescriptionChanged={this.handleDescriptionChanged} code={this.state.description} />
        }

        return (
            <>

                <Menu entries={[{ type: EntryType.Save, onClick: this.handleSave, show: this.canSaveStatistic() }]} onSelect={() => { }} enableMenuItem={() => true} handleEval={() => { }} />
                <div className="dashboardContent" >
                    {this.showWarningIfCantSave()}
                    <EditorTabControl selectedTab={this.state.selectedTab} onTabClicked={this.handleTabClicked}>
                        {previewOrCode}
                    </EditorTabControl>

                </div>
                <div className="leftSidebar">
                    <react_components.SideBar header="UI">

                        <ui_editor_Components.JsonTree ui={this.state.ui}
                            onDeleteElement={this.handleDeleteElement}
                            onDeleteRow={this.handleDeleteRow}
                            onElementClicked={this.handleElementClicked}
                            onAddElement={this.handleAddElement}
                            onAddListItem={this.handleAddListItem}
                            onMoveElement={this.handleMoveElement}
                            onCopyElement={this.handleCopyElement}
                            selectedElement={this.state.selectedElement} />
                    </react_components.SideBar>
                </div>

                <div className="rightSidebar">
                    <react_components.SideBar header="PROPERTIES">{editor}</react_components.SideBar>
                </div>
                <input style={{ visibility: "hidden" }} />
            </>
        );
    }
};

class UiPreview extends React.Component<any, any>{
    handleValueChanged = (name, value) => {
        this.props.onValueChanged(name, value);
    }

    createStatisticViewer = (statisticId, queryParams, drillDownParams, uiDefinition, controllerCode, contextVariables, realStatisticID) => {
        return (
            <StatisticViewer
                dataStore={this.props.dataStore}
                key={statisticId}
                statisticId={statisticId}
                uiDefinition={uiDefinition}
                parameters={queryParams}
                controllerCode={controllerCode}
                contextVariables={contextVariables}
                hideParameters={false}
                drillDownParams={drillDownParams}
                drillDowny={null}
                realStatisticId={realStatisticID}
            >
            </StatisticViewer>
        )
    }
    render() {
        var ui = this.props.ui;
        if (this.props.ui && this.props.contextVariables) {
            var statisticUi = this.createStatisticViewer(this.props.statisticId, this.props.values, null, ui, this.props.code, this.props.contextVariables, this.props.statisticId);
        }
        return <div>
            <ul style={{
                fontSize: "18px",
                padding: "8px 15px",
                marginBottom: "20px",
                listStyle: "none",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px"
            }}>
                <li>{this.props.name}</li>
            </ul>
            <ErrorBoundary>
                {statisticUi}
            </ErrorBoundary>
        </div >
    }
};


var getEditorForSelectedElement = function (selectedElement) {
    var type = (selectedElement || {}).type;

    if (type) {
        return utility.getEditorMetadata(type);
    }

    return null;
};

class EditorTabControl extends React.Component<any, any>{
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleTabClick = (index, e) => {
        e.preventDefault();
        this.props.onTabClicked(index)
    }

    render() {
        const style = {
            border: "none",
            outline: "none",
            padding: "14px 16px",
            backgroundColor: "inherit"
        }

        const selectedStyle = { ...style };
        selectedStyle.backgroundColor = "#ccc";

        return (<react_components.ReactColumn width={12}>
            <div className="nav-tabs-custom">
                <button style={this.props.selectedTab == 0 ? selectedStyle : style} onClick={this.handleTabClick.bind(this, 0)} >Preview</button>
                <button style={this.props.selectedTab == 1 ? selectedStyle : style} onClick={this.handleTabClick.bind(this, 1)} >Code</button>
                <button style={this.props.selectedTab == 2 ? selectedStyle : style} onClick={this.handleTabClick.bind(this, 2)} >Description</button>
                <div className="tab-content" style={{ margin: "15px" }}>
                    {this.props.children}
                </div>
            </div>
        </react_components.ReactColumn >);

    }
};

export class UiBuilderEditor extends React.Component<TextEditorProps, any>{
    render() {
        let editor = <MonacoEditor onKeyPress={this.props.onKeyPress} onTextChange={this.props.onTextChange} code={this.props.code} name={this.props.name} language={this.props.language} extraLibs={this.props.extraLibs}></MonacoEditor>
        return editor;
    }
}

class DescriptionEditor extends React.Component<any, any>{
    constructor(props) {
        super(props);

        this.state = { template: props.code };
    }

    handleDescriptionChanged = (description) => {
        this.props.onDescriptionChanged(description);
    }

    handleKeyPress = (description) => {
        this.setState({ template: description });
    }

    getColumnTemplate = (template) => {
        if (!template) {
            return { __html: "" };
        }
        try {
            template = kendo.template(template);
            var result: any;
            result = template({});
        }
        catch (e) {
            result = '<div style = "color:red">Error in template:' + e.message + '</div>';
        }
        return { __html: result };
    }

    render() {
        return (
            <div>
                <div style={{ height: "500px" }}>
                    <UiBuilderEditor name="description" onTextChange={this.handleDescriptionChanged} code={this.props.code} onKeyPress={this.handleKeyPress} language="text" />
                </div>
                Preview
                < hr />
                <div style={{ height: "500px", overflowY: "auto" }} dangerouslySetInnerHTML={this.getColumnTemplate(this.state.template)}></div>
            </div>);
    }
};